import type { DataSource } from "src/features/integrations/overview/table/IntegrationsTableContent.js";
import { resolveDataSourceStatusKind } from "src/features/integrations/status/resolveSyncStatusKind.js";

export type DataSourceHealth = "needsAttention" | "syncing" | "inSync";

export const classifyDataSource = (
	dataSource: DataSource,
): DataSourceHealth => {
	switch (resolveDataSourceStatusKind(dataSource)) {
		case "attention":
			return "needsAttention";
		case "syncing":
		case "queued":
			return "syncing";
		default:
			return "inSync";
	}
};

const HEALTH_ORDER: Record<DataSourceHealth, number> = {
	needsAttention: 0,
	syncing: 1,
	inSync: 2,
};

export interface DataSourceStatusRow {
	id: string;
	name: string;
	health: DataSourceHealth;
	lastSuccessfulSyncAt: string | null;
	/** The full record — the view renders the same icon/status/link as the data-sources table from this. */
	dataSource: DataSource;
}

export const toStatusRows = (
	dataSources: DataSource[],
	limit: number,
): DataSourceStatusRow[] => {
	return dataSources
		.map((dataSource) => ({
			id: `${dataSource.type}-${dataSource.id}`,
			name: dataSource.name,
			health: classifyDataSource(dataSource),
			lastSuccessfulSyncAt: dataSource.lastSuccessfulSyncAt,
			dataSource,
		}))
		.sort(
			(a, b) =>
				HEALTH_ORDER[a.health] - HEALTH_ORDER[b.health] ||
				a.name.localeCompare(b.name, "sv"),
		)
		.slice(0, limit);
};
